import { logError } from '@iwLogger/IwDataDogLogger';
import { getQueryParameter } from '@iwRouter/LocationHelper';
import { fetchPostPageView } from '@iwoca/lapi-client/edge';

export const trackPageView = (stateKey: string, name: string) => {
    const impersonatingStateKey = getQueryParameter(
        window.location,
        'state_key'
    );

    if (!impersonatingStateKey) {
        fetchPostPageView({
            stateKey: stateKey,
            body: { data: { name } }
        }).catch((exc) =>
            logError(`Page view for ${name} has not been logged.`, {
                exception: exc
            })
        );
    } else {
        console.warn(
            `Page View not tracked for impersonating user: ${stateKey}`
        );
    }
};
